import { Component } from '@angular/core';

@Component({
  selector: 'app-newforgot',
  templateUrl: './newforgot.component.html',
  styleUrls: ['./newforgot.component.css'],
  standalone: false,
})
export class NewforgotComponent {
  passwordFieldType: string = 'password';

  togglePasswordVisibility(): void {
    this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password';
  }
}
